import { Injectable, InjectionToken, Inject, Optional } from '@angular/core';

export interface TimezoneConfiguration {
  timezoneOffsetInMilliseconds: number;
}

export const TIMEZONE_CONFIGURATION = new InjectionToken<TimezoneConfiguration>('timezoneOffsetMs');

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  constructor(@Optional() @Inject(TIMEZONE_CONFIGURATION) private timezoneConfiguration: TimezoneConfiguration) {
  }

  /**
   * @returns Date object
   *
   * @description
   * Returns current timestamp adjusted for server timezone
   *
   */
  getCurrentDateInServerTimezone(): Date {
    return this.adjustToServerTimezone(new Date());
  }

  /**
   * @param localDate Date to adjust. Can be string representation of date
   * @returns  adjusted date
   *
   * @description
   *
   * Adjust date to  EST timezone.
   * Should not be used for past dates because if does not take into account DST
   */
  adjustToServerTimezone(localDate: Date): Date {
    const utcMs: number = localDate.getTime() + (localDate.getTimezoneOffset() * 60000);
    const offset =  this.timezoneConfiguration !== undefined && this.timezoneConfiguration !== null ?
      this.timezoneConfiguration.timezoneOffsetInMilliseconds : 0;
    return new Date(utcMs + offset);
  }

  /**
   * @name getYesterdayInServerTimezone
   * @returns
   * @description
   * Returns last day in server timezone
   */
  getYesterdayInServerTimezone(): Date {
    const date: Date = this.getCurrentDateInServerTimezone();
    date.setDate(date.getDate() - 1);
    return date;
  }

}
